
import React from 'react';
import { motion } from 'framer-motion';
import { Alert } from '@/components/ui/alert';
import { AlertIcon } from './AlertIcon';
import { AlertContent } from './AlertContent';

const InfoAlert: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1, duration: 0.5 }}
      className="max-w-3xl mx-auto mb-4 md:mb-5"
    >
      <Alert className="border-l-4 border-l-blue-500 bg-gradient-to-r from-blue-50 to-white shadow-sm py-2.5 md:py-3">
        <AlertIcon />
        <AlertContent />
      </Alert>
    </motion.div>
  );
};

export default InfoAlert;
